export const inspections = [
  {
    path: '/inspections',
    name: 'Inspections',
    component: () => import('./index.vue'),
    meta: {
      rule: 'INSPECTIONS',
      authRequired: true,
      title: 'general.inspections',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/'
        },
        {
          text: 'general.inspections',
          disabled: true,
          href: '#/inspections'
        }
      ]
    }
  },
  {
    path: '/inspections/view/:id',
    name: 'viewInspection',
    component: () => import('./form.vue'),
    meta: {
      rule: 'INSPECTION_READ',
      authRequired: true,
      title: 'inspections.view',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/'
        },
        {
          text: 'general.inspections',
          disabled: false,
          href: '#/inspections'
        },
        {
          text: 'inspections.view',
          disabled: true
        }
      ]
    }
  }
]